// i18n area 'auth' — locale de-DE (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.de-DE.meta.json.
import type { enUS } from './auth'

export const deDE: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Melden Sie sich an Ihrem Konto an',
    username: 'Benutzername',
    usernamePlaceholder: 'Geben Sie den Benutzernamen ein',
    usernameHint: 'Verwenden Sie benutzer@domäne, um sich an einem Directory-Realm zu authentifizieren',
    continue: 'Weiter',
    changeUser: 'Nicht Sie?',
    password: 'Passwort',
    forgotPassword: 'Passwort vergessen?',
    submit: 'Anmelden',
    otp: 'Einmalcode',
    otpSubtitle: 'Geben Sie den Code Ihres Authenticators ein',
    otpHint: 'Sechs Ziffern aus der Authenticator-App, oder einer Ihrer Wiederherstellungscodes',
    otpSubmit: 'Verifizieren',
    invalidCredentials: 'Benutzername oder Passwort ungültig',
    tooManyAttempts: 'Zu viele Versuche — warten Sie einen Moment und versuchen Sie es erneut',
    realmUnavailable: 'Der Realm kann die Anmeldedaten gerade nicht prüfen — der Cluster-Store ist nicht erreichbar. Melden Sie sich als lokaler Benutzer an (Break-Glass).',
    genericError: 'Anmeldung fehlgeschlagen — ist das TVirt-Backend erreichbar?'
  },
  user: {
    logout: 'Abmelden',
    password: {
      menu: 'Passwort ändern',
      title: 'Ihr Passwort ändern',
      current: 'Aktuelles Passwort',
      new: 'Neues Passwort',
      confirm: 'Neues Passwort bestätigen',
      mismatch: 'Die Passwörter stimmen nicht überein',
      error: 'Das Passwort konnte nicht geändert werden',
      forcedTitle: 'Ändern Sie das Passwort, um fortzufahren',
      forcedHint: 'Dieses Passwort wurde von einem Administrator gesetzt und muss vor dem Eintreten ersetzt werden.',
      forcedSubmit: 'Ändern und eintreten'
    },
    mfa: {
      title: 'Zwei-Faktor-Authentifizierung',
      subtitle: 'Ein zweiter Faktor, abgefragt bei jeder Anmeldung',
      loadError: 'Der Zustand des zweiten Faktors konnte nicht geladen werden',
      enrolled: 'Aktiv',
      notEnrolled: 'Nicht aktiv',
      enrolledAt: 'Aktiviert am',
      codesRemaining: 'Verbleibende Wiederherstellungscodes',
      requiredHint: 'Ein Administrator verlangt auf diesem Konto einen zweiten Faktor: Richten Sie ihn jetzt ein — bis dahin können Sie sich anmelden, aber kaum mehr.',
      enroll: 'Einrichten',
      enrollTitle: 'Zwei-Faktor-Authentifizierung einrichten',
      enrollHint: 'Scannen Sie diesen Code mit der Authenticator-App und tippen Sie dann den angezeigten Code ein, um zu bestätigen.',
      secretHint: 'Sie können ihn nicht scannen? Geben Sie stattdessen dieses Geheimnis in die App ein:',
      code: 'Code aus der App',
      confirm: 'Bestätigen',
      startError: 'Die Einrichtung konnte nicht gestartet werden',
      confirmError: 'Die Einrichtung konnte nicht bestätigt werden',
      codesTitle: 'Ihre Wiederherstellungscodes',
      codesWarning: 'Diese Codes werden nur ein einziges Mal angezeigt. Speichern Sie sie jetzt: Jeder meldet Sie an, wenn der Authenticator nicht verfügbar ist, und jeder gilt nur einmal.',
      codesAck: 'Ich habe die Wiederherstellungscodes gespeichert',
      codesDone: 'Fertig',
      copy: 'Kopieren',
      copied: 'Kopiert',
      download: 'Herunterladen',
      regenerate: 'Neue Wiederherstellungscodes',
      regenerateTitle: 'Wiederherstellungscodes neu generieren',
      regenerateHint: 'Alle bisher ausgestellten Codes hören in dem Moment auf zu funktionieren, in dem das neue Set generiert wird.',
      regenerateConfirm: 'Neu generieren',
      regenerateError: 'Die Wiederherstellungscodes konnten nicht neu generiert werden',
      remove: 'Entfernen',
      removeTitle: 'Zweiten Faktor entfernen',
      removeConfirm: 'Entfernen',
      removeHint: 'Das Konto kehrt zum reinen Passwort zurück. Sie können den zweiten Faktor jederzeit neu einrichten.',
      removeRequiredHint: 'Ein Administrator verlangt auf diesem Konto einen zweiten Faktor, daher wird der Server die Entfernung ablehnen — bitten Sie zuerst darum, die Pflicht aufzuheben.',
      removeError: 'Der zweite Faktor konnte nicht entfernt werden'
    },
    profile: {
      menu: 'Zu meinem Profil',
      sessions: 'Aktive Sitzungen',
      sessionsHint: 'Ihre offenen Sitzungen auf diesem Knoten',
      sessionsEmpty: 'Keine aktiven Sitzungen',
      sessionCreated: 'Angemeldet',
      sessionExpires: 'Läuft ab',
      revoke: 'Sitzung widerrufen',
      revokeError: 'Die Sitzung konnte nicht widerrufen werden',
      loadError: 'Die Sitzungen konnten nicht geladen werden'
    }
  }
}
